import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { NgxMessageService } from '@digipay/ngx-message-service';
import { UpdateVersionService } from '../../../../shared/update-version.service';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'app-crowd-header',
  templateUrl: './crowd-header.component.html',
  styleUrls: ['./crowd-header.component.scss'],
  standalone: true,
  imports: [SharedModule, NgxButtonComponent],
})
export class CrowdHeaderComponent implements OnInit {
  @Input() backIcon: boolean = true;
  @Input() exteraContent: boolean = true;
  @Input() isHome: boolean = false;
  @Input({ required: true }) pageTitle!: string;
  @Input() pageTitleOptions: string;
  @Input() showVersion? = false;
  @Input() backgroundColor?: string;

  @Output() onBack = new EventEmitter();

  private clickCount = 0;
  private clickTimeout: any;

  constructor(
    private ms: NgxMessageService,
    private updateVersionService: UpdateVersionService,
  ) {}

  ngOnInit() {}

  onBackClicked() {
    this.onBack.emit();
  }

  handleShowVersion() {
    if (!this.showVersion) return;
    this.clickCount++;

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
    }

    if (this.clickCount === 6) {
      this.ms.showSuccessMessage(this.updateVersionService.getAppVersion());
      this.resetClickCount();
    } else {
      this.clickTimeout = setTimeout(() => this.resetClickCount(), 1000);
    }
  }

  resetClickCount() {
    this.clickCount = 0;
  }
}
